import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(private http:HttpClient) { }

  public verifyUserId(userId): Observable<any>{
    return this.http.post(environment.BASE_URL_PROFILE+'auth/verifyUser', userId)
  }

  public getToken(payload): Observable<any>{
    let headers = new HttpHeaders();
    headers = headers.append('Authorization', 'Basic ' + btoa(payload.username+":"+payload.password));
    headers = headers.append("X-Requested-With", "XMLHttpRequest");
    let httpOptions = { headers: headers }; 
    return this.http.get(environment.BASE_URL_PROFILE+'auth/getToken')
  }

  public getIpLocation():Observable<any>{
    return this.http.get('https://freegeoip.app/json/')
  }
}
